export const CLEAR_ALERTS = 'CLEAR_ALERTS'
export const CREATE_ALERT = 'CREATE_ALERT'
export const REMOVE_ALERT = 'REMOVE_ALERT'

export function clearAlerts(scope) {
  return {
    type: CLEAR_ALERTS,
    scope
  }
}

export function createAlert(alert) {
  return {
    type: CREATE_ALERT,
    alert
  }
}

export function removeAlert(alert) {
  return {
    type: REMOVE_ALERT,
    alert
  }
}



// WEBPACK FOOTER //
// ../src/actions/alertActions.js